module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon13.1b00aef8.png";